export const SYNONYMS_BEGIN_WAIT = "SYNONYMS_BEGIN_WAIT";
export const SYNONYMS_END_WAIT = "SYNONYMS_END_WAIT";

export const SYNONYMS_UPDATE_SYNONYMS = "SYNONYMS_UPDATE_SYNONYMS";
